import { captureStack1fzi4aczwc4hg as captureStack } from '../../js/coreRuntime.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../exceptions.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function init_kotlin_coroutines_cancellation_CancellationException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.h_1);
}
var CancellationExceptionClass;
function CancellationException() {
  if (CancellationExceptionClass === VOID) {
    class $ extends IllegalStateException() {
      static i() {
        var $this = this.m();
        init_kotlin_coroutines_cancellation_CancellationException($this);
        return $this;
      }
      static n(message) {
        var $this = this.o(message);
        init_kotlin_coroutines_cancellation_CancellationException($this);
        return $this;
      }
      static p(message, cause) {
        var $this = this.q(message, cause);
        init_kotlin_coroutines_cancellation_CancellationException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'CancellationException', $.i);
    CancellationExceptionClass = $;
  }
  return CancellationExceptionClass;
}
//region block: exports
export {
  CancellationException as CancellationException3b36o9qz53rgr,
};
//endregion

//# sourceMappingURL=CancellationException.mjs.map
